export default `ids-popup::part(popup) {
  max-width: 335px;
}

.ids-modal-container ids-empty-message {
  height: 310px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtZXJyb3ItcGFnZSIsInNvdXJjZXMiOlsiaWRzLWVycm9yLXBhZ2Uuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFOzs7QUFJQTtFQUNFIiwic291cmNlc0NvbnRlbnQiOlsiaWRzLXBvcHVwOjpwYXJ0KHBvcHVwKSB7XG4gIG1heC13aWR0aDogMzM1cHg7XG59XG5cbi5pZHMtbW9kYWwtY29udGFpbmVyIHtcbiAgaWRzLWVtcHR5LW1lc3NhZ2Uge1xuICAgIGhlaWdodDogMzEwcHg7XG4gIH1cbn1cbiJdfQ== */`;
